import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showError } from 'actions/CommonActions';
import { formError, formInput, clearFormInput } from 'actions/FormActions';
import { adjustProductQty, getAuditWarehouses } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import util from 'library/util';
import SelectInput from 'screens/components/basic/SelectInput';
import { mapAuditAdjust } from 'utils/mappers';
import GenericTable from 'screens/components/advanced/GenericTable';
import DecimalInputOnePlace from 'screens/components/basic/DecimalInputOnePlace';
import DialogHeaderWithClose from '../../../components/basic/DialogHeaderWithClose';

const dialogStyle = {
    width: '70%',
    maxWidth: 'none'
};

class AdjustInventoryDialog extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            open: false,
            warehouses: null,
            pendingBulkTransferProducts: null
        };
    }

    componentWillMount() {
        this.props.getAuditWarehouses({ Id: this.props.productId, branchId: this.props.branchId });
        this.setState({ open: this.props.openAdjust });
    }

    componentWillReceiveProps(newProps) {

        if (this.props.auditWarehouses != newProps.auditWarehouses && newProps.auditWarehouses.productId == this.props.productId) {
            this.setState({ warehouses: newProps.auditWarehouses.packages, pendingBulkTransferProducts: newProps.auditWarehouses.pendingBulkTransferProducts })
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput(`warehouseAdjustmentTableSelectedRows`);
        this.props.clearFormInput(`${this.props.name}ReasonId`);
        this.props.clearFormInput(`${this.props.name}Amount`);
        this.props.clearFormInput(`${this.props.name}Notes`);
        this.props.clearFormInput(`${this.props.name}OtherReductionReason`);
        this.props.clearFormInput(`${this.props.name}ExpectedQuantity`);
        this.props.clearFormInput(`${this.props.name}DestroyMethod`);
        this.props.clearFormInput(`${this.props.name}DestroyReason`);
    }


    confirmAdjustment = (maxQuantity) => {
        let p = this.props;
        //Getting the warehouse selected row
        let selectedWarehouse = null;
        let reason = this.props.reason;
        let destroyMethod = this.props.destroyMethod;
        let destroyReason = this.props.destroyReason;
        let otherReductionReason = this.props.otherReductionReason;
        let notes = this.props.notes;
        if (this.props.selectedRows !== null && this.props.selectedRows !== undefined) {
            selectedWarehouse = this.state.warehouses[this.props.selectedRows[0]];
        } else {
            if (!this.props.lockExpectedQuantity) {
                this.props.showError("Please select the warehouse you want to adjust");
                return;
            }
        }

        if (selectedWarehouse != null) {
            if (this.props.amount > selectedWarehouse.quantity) {
                reason = 10;
            }

            if (!this.props.lockExpectedQuantity && this.props.amount == selectedWarehouse.quantity) {
                this.props.showError("Actual quantity must be different from the expected quantity");
                return;
            }
        }

        let model = {
            amount: this.props.amount,
            productId: this.props.product.id,
            packageReference: selectedWarehouse ? selectedWarehouse.packageReference : '',
            warehouseId: selectedWarehouse ? selectedWarehouse.warehouseId : null,
            branchId: this.props.branchId,
            reason: reason,
            destroyMethod: destroyMethod,
            destroyReason: destroyReason,
            otherReductionReason: otherReductionReason,
            notes: notes,
            placeOfInventoryChange: this.props.placeOfInventoryChange,
            auditId: this.props.audit.id
        };


        //for other reduction or addition, reason is mandatory
        if ((reason == 10 || reason == 9) && (otherReductionReason == '' || otherReductionReason == undefined || otherReductionReason == null)) {
            this.props.showError('please input other addition/reduction reason');
            return;
        }

        let validators = [];

        if (this.props.lockExpectedQuantity) {
            validators = [
                [p.name + 'ExpectedQuantity', model => (this.props.expectedQuantity !== null && this.props.expectedQuantity !== "" && this.props.expectedQuantity >= 0), "ExpectedQuantity"]
            ]

            if (model.warehouseId !== null && model.warehouseId !== "")
            {
                validators.push(
                    [p.name + 'Amount', model => (this.props.amount !== null && this.props.amount !== "" && this.props.amount >= 0), "Amount"],
                    [p.name + 'ReasonId', model => (model.reason !== null && model.reason !== ""), "ReasonId"]
                );
            }
        } else {
            validators = [
                [p.name + 'Amount', model => (this.props.amount !== null && this.props.amount !== "" && this.props.amount >= 0), "Amount"],
                [p.name + 'ReasonId', model => (model.reason !== null && model.reason !== ""), "ReasonId"],
                [p.name + 'Warehouse', model => (model.warehouseId !== null && model.warehouseId !== ""), "Warehouse"]
            ];

        }


        if (this.props.lockExpectedQuantity) {
            if (util.validate(validators, model, this.props.formError)) {
                this.props.updateAuditProductExpectedQuantity(this.props.product.id, this.props.product.warehouseType, this.props.expectedQuantity)
                if (model.warehouseId !== null && model.warehouseId !== "") {
                    this.props.adjustProductQty(model);
                }
                this.onClose();
            }
        } else {
            if (util.validate(validators, model, this.props.formError)) {
                this.props.adjustProductQty(model);
                this.props.updateAuditProductDiffQty();
                this.onClose();
            }
        }
    }

    onClose = () => {
        this.props.onClose();
        this.props.formInput(this.props.name + 'Amount', null);
        this.props.formError(this.props.name + 'Amount', null);
        this.props.formInput(this.props.name + 'ReasonId', null);
        this.props.formError(this.props.name + 'ReasonId', null);
        this.setState({ open: false });
        this.props.setIsAdjust();
    }

    render() {
        const p = this.props;
        const s = this.state;

        const actions = [
            <Button
                key={1}
                type="CancelButton"
                className="btn-space"
                label={LOOKUP.common.cancel.text}
                secondary={true}
                onTouchTap={() => this.onClose()}
            />,
            <Button
                key={2}
                className="pull-right btn-space"
                type="RaisedButton"
                id="confirmInventoryAdjust"
                label={"Confirm"}
                onTouchTap={() => this.confirmAdjustment(row !== null && row !== undefined ? warehouses[row[0]].quantity : 0)}
            />
        ];

        let product = p.product;
        let warehouses = [];
        if (this.state.warehouses !== null && this.state.warehouses !== undefined) {
            warehouses = this.state.warehouses;
        }

        let pendingBulkTransferProducts = [];
        if (this.state.pendingBulkTransferProducts !== null && this.state.pendingBulkTransferProducts !== undefined) {
            pendingBulkTransferProducts = this.state.pendingBulkTransferProducts;
        }

        let row = this.props.selectedRows;
        let adjustTableRows  = mapAuditAdjust(warehouses, this.props.productId, pendingBulkTransferProducts);

        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text="Inventory Adjustment" classicClass="posDialogClassic" handleClose={() => this.onClose()} />}
                    actions={actions}
                    modal={true}
                    className="adjust_Product"
                    open={s.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}>
                    <div className="adjustProducts">
                        <div>
                            <div className="form-group">

                                <div className="row m-0 product-info-modal-transfer">
                                    <div className="col-lg-12">
                                        <h4>{product ? `Product Name: ${product.name} ` : ''}</h4>
                                        <p>
                                            {product ? `SKU: ${product.sku}` : ''}<br />
                                        </p>
                                    </div>
                                </div>

                                <div className="row m-0">
                                    <div className="col-lg-12">
                                        <h4>Select the Warehouse</h4>
                                        <GenericTable
                                            className="table-inventory"
                                            compName="warehouseAdjustmentTable"
                                            tableHeaderClassName="table-products-header"
                                            tableBodyClassName="table-products"
                                            adjustForCheckbox={true}
                                            displaySelectAll={false}
                                            displayRowCheckbox={true}
                                            enableSelectAll={false}
                                            multiSelectable={false}
                                            selectable={true}
                                            stripedRows={true}
                                            columns={LOOKUP.inventoryAudit.adjustauditTableColumns}
                                            rows={adjustTableRows}
                                        />
                                    </div>
                                </div>

                                <div className="row m-0">
                                    <div className="col-lg-12">
                                        {
                                            row !== null && row !== undefined && row.length > 0 && (
                                                this.props.isMedical ?
                                                    <div>
                                                        <DecimalInputOnePlace name={`${this.props.name}Amount`}
                                                            type="number"
                                                            hintText={"Please input the Actual Quantity"}
                                                            fullWidth={true}
                                                            label="Amount"
                                                            floatingLabelText="Actual Quantity"
                                                        />
                                                    </div>
                                                    :
                                                    <div>
                                                        <TextInput name={`${this.props.name}Amount`}
                                                            hintText={"Please input the Actual Quantity"}
                                                            type="number"
                                                            fullWidth={true}
                                                            label="Amount"
                                                            floatingLabelText="Actual Quantity"
                                                        />
                                                    </div>
                                            )
                                        }
                                    </div>
                                </div>
                                {
                                    row !== null && row !== undefined && row.length > 0 && (this.props.amount == 0 ? true : adjustTableRows[row].quantity > parseInt(this.props.amount || adjustTableRows[row].quantity)) &&
                                    (
                                        <div className="row m-0">
                                            <div className="col-lg-12">
                                                {
                                                    this.props.amount < adjustTableRows[row].pendingTransfer &&
                                                    <h5 className="orange-text">Warning: Adjusting the quantity below the pending outward quantity may prevent bulk transfers from being completed.</h5>
                                                }
                                                <SelectInput
                                                    name={`${this.props.name}ReasonId`}
                                                    fullWidth={true}
                                                    id="selectReasonId"
                                                    label={`Reason`}
                                                    floatingLabelText={`Reason`}
                                                    options={LOOKUP.transferProduct.transferProductReasons.forAdjustment}
                                                    hintText={`Reason`} />
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    this.props.reason && this.props.reason == 5 &&
                                    (
                                        <div className="row m-0">
                                            <div className="col-lg-12">
                                                <TextInput name={`${this.props.name}DestroyMethod`}
                                                    hintText={"Please input the Destory Method"}
                                                    fullWidth={true}
                                                    label="Destory Method"
                                                    floatingLabelText="Destory Method"
                                                />
                                            </div>
                                            <div className="col-lg-12">
                                                <TextInput name={`${this.props.name}DestroyReason`}
                                                    hintText={"Please input the Destory Reason"}
                                                    fullWidth={true}
                                                    label="Destory Reason"
                                                    floatingLabelText="Destory Reason"
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    ((this.props.reason && this.props.reason == 9) || (this.props.selectedRows && this.state.warehouses && this.state.warehouses[this.props.selectedRows[0]] && this.props.amount > this.state.warehouses[this.props.selectedRows[0]].quantity)) &&
                                    (
                                        <div className="col-lg-12">
                                          {
                                            !this.props.isVape && (this.props.province.toLowerCase() == "on" || this.props.province.toLowerCase() == "ontario") ?
                                                <SelectInput
                                                  name={`${this.props.name}OtherReductionReason`}
                                                  fullWidth={true}
                                                  label={`Reason`}
                                                  id="selectOtherReductionReason"
                                                  floatingLabelText={`Reason`}
                                                  options={LOOKUP.transferProduct.transferProductReasons.ocsOtherAdjustmentReasons}
                                                  hintText={`Reason`} />
                                                :
                                                <TextInput name={`${this.props.name}OtherReductionReason`}
                                                  hintText={"Please input the other addition/reduction reason"}
                                                  fullWidth={true}
                                                  label="Other Addition/Reduction Reason"
                                                  floatingLabelText="Other Addition/Reduction Reason"
                                                />
                                          }
                                          {/* //adjustmentInventoryDialogOtherReductionReasonText */}
                                        </div>
                                    )
                                }
                                {
                                    row !== null && row !== undefined && row.length > 0 &&
                                    (
                                        <div className="col-lg-12">
                                            <TextInput name={`${this.props.name}Notes`}
                                                hintText={"Please input the notes"}
                                                fullWidth={true}
                                                label="Notes"
                                                floatingLabelText="Notes"
                                            />
                                        </div>
                                    )
                                }

                                {this.props.lockExpectedQuantity ?

                                    this.props.isMedical ?
                                    <div>
                                        <DecimalInputOnePlace
                                            type="number"
                                            name={`${this.props.name}ExpectedQuantity`}
                                            hintText={"Please input the correct Expected Quantity"}
                                            fullWidth={true}
                                            label="Expected Quantity"
                                            floatingLabelText="Expected Quantity"
                                        />
                                    </div>
                                    :
                                    <div>
                                        <TextInput
                                            name={`${this.props.name}ExpectedQuantity`}
                                            hintText={"Please input the correct Expected Quantity"}
                                            type="number"
                                            fullWidth={true}
                                            label="Expected Quantity"
                                            floatingLabelText="Expected Quantity"
                                        />
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        product: state.entity.productForAdjustment,
        selectedRows: state.form["warehouseAdjustmentTableSelectedRows"],
        amount: state.form[`${ownProps.name}Amount`] ? parseFloat(state.form[`${ownProps.name}Amount`]) : null,
        expectedQuantity: state.form[`${ownProps.name}ExpectedQuantity`] ? parseFloat(state.form[`${ownProps.name}ExpectedQuantity`]) : null,
        reason: state.form[`${ownProps.name}ReasonId`] ? state.form[`${ownProps.name}ReasonId`] : null,
        destroyMethod: state.form[`${ownProps.name}DestroyMethod`] ? state.form[`${ownProps.name}DestroyMethod`] : null,
        destroyReason: state.form[`${ownProps.name}DestroyReason`] ? state.form[`${ownProps.name}DestroyReason`] : null,
        otherReductionReason: state.form[`${ownProps.name}OtherReductionReason`] ? state.form[`${ownProps.name}OtherReductionReason`] : null,
        notes: state.form[`${ownProps.name}Notes`] ? state.form[`${ownProps.name}Notes`] : null,
        isMedical: state.common.applicationSettings.isMedical,
        auditWarehouses: state.entity.auditWarehouses,
        province: state.common.applicationSettings.storeProvinceState,
        isVape: state.common.applicationSettings.isVape
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formError: (name, error) => dispatch(formError(name, error)),
        formInput: (name, value) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        adjustProductQty: (model) => dispatch(adjustProductQty(model)),
        getAuditWarehouses: (model) => dispatch(getAuditWarehouses(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdjustInventoryDialog);